// extracted by mini-css-extract-plugin
export const wrapper = "Highlights-module--wrapper--FGdug";
export const content = "Highlights-module--content--3YtF4";
export const item = "Highlights-module--item--JGjOs";
export const icon = "Highlights-module--icon--1YDqM";